var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusculoskeletal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.442,
    height: 37.429,
    viewBox: "0 0 37.442 37.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(-337 -329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M480.434,230.724a20.742,20.742,0,0,1,1.856,1.579c.157.2,1.478,1.966,1.663,2.221s1.106,1.753,1.106,1.753l-1.106,2.3-2.219,2.3v2.408l2.748,2.688,2.5,2.5h2.3a4.911,4.911,0,0,0,1.5-.328c.156-.2.621-.741.884-1.017s1.292-1.152,1.292-1.152.588-.492.946-.429a6.991,6.991,0,0,1,1.842.693c.243.218,2.938,2.232,2.938,2.232l.956,1.612-1.361,3.088-2.533,1.794s-3.11.774-3.342.774-5.518-1.151-5.807-1.243-4.862-3.444-4.862-3.444l-4.211-4.812a36.01,36.01,0,0,1-2.374-4.358c-.009-.492-.363-6-.363-6l2.155-3.577,1.97-1.2Z",
    transform: "translate(-137 110)",
    fill: "#8db147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(385.456 110.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "appointment-types__type-svg-fill",
    id: "Path_185-2",
    "data-name": "Path 185",
    d: "M-23.175,247.279c-.237-.191-3.006-2.428-3.686-2.949a2.464,2.464,0,0,0-2.021-.562A5.212,5.212,0,0,0-31.759,246a2.413,2.413,0,0,1-3.284.926,2.277,2.277,0,0,1-.3-.2.731.731,0,0,0-1,.276.731.731,0,0,0,.275,1h0a3.852,3.852,0,0,0,5.363-.96c.029-.042.058-.085.085-.129l5.948,4.758a7.162,7.162,0,0,1-3.111,1.952c-2.376.767-7.3,1.113-13.612-5.2s-5.962-11.232-5.2-13.608a7.179,7.179,0,0,1,1.946-3.1l4.758,5.945a3.851,3.851,0,0,0-1.165,5.319c.026.042,4.638,4.667,4.666,4.707a.732.732,0,0,0,1,.276.732.732,0,0,0,.275-1l-4.584-4.584a2.412,2.412,0,0,1,.43-3.385,2.484,2.484,0,0,1,.3-.2,5.2,5.2,0,0,0,2.233-2.877,2.466,2.466,0,0,0-.562-2.021c-.52-.681-2.757-3.45-2.949-3.686a2.684,2.684,0,0,0-2.684-.994c-2.1.341-4.182,2.457-5.05,5.147a11.119,11.119,0,0,0,.1,6.764,21,21,0,0,0,5.449,8.332,21,21,0,0,0,8.332,5.449,12.211,12.211,0,0,0,3.657.582,10.044,10.044,0,0,0,3.107-.477c2.69-.869,4.806-2.946,5.147-5.05a2.684,2.684,0,0,0-.994-2.684Zm-19.519-16.618a1.225,1.225,0,0,1,1.283.431l.021.027c.024.03,2.414,2.987,2.934,3.668a1.013,1.013,0,0,1,.287.86,2.252,2.252,0,0,1-.619,1.038l-4.635-5.795A3,3,0,0,1-42.694,230.661Zm13.052,15.158a2.26,2.26,0,0,1,1.032-.614,1.015,1.015,0,0,1,.86.287c.68.52,3.638,2.91,3.668,2.934l.027.021a1.225,1.225,0,0,1,.431,1.283,2.9,2.9,0,0,1-.225.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M-22.721,218.059a11.7,11.7,0,0,0-11.7,11.7,11.7,11.7,0,0,0,1.556,5.829l-.868,3.238a1.565,1.565,0,0,0,.418,1.534,1.586,1.586,0,0,0,1.537.4l3.221-.864a11.7,11.7,0,0,0,15.978-4.3,11.7,11.7,0,0,0-4.3-15.978A11.718,11.718,0,0,0-22.721,218.059Zm0,21.934a10.209,10.209,0,0,1-5.343-1.5.732.732,0,0,0-.572-.083l-3.523.945h-.009a.116.116,0,0,1-.119-.033.11.11,0,0,1-.032-.115l.948-3.534a.732.732,0,0,0-.083-.572,10.236,10.236,0,0,1,3.388-14.075,10.236,10.236,0,0,1,14.075,3.387,10.237,10.237,0,0,1-3.387,14.076,10.242,10.242,0,0,1-5.344,1.505Z",
    fill: "#9d9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M-19.065,225.365h-7.311a.733.733,0,0,0-.73.733.731.731,0,0,0,.73.729h7.311a.73.73,0,0,0,.73-.732A.731.731,0,0,0-19.065,225.365Z",
    fill: "#9d9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M-19.065,229.026h-7.311a.732.732,0,0,0-.731.731.731.731,0,0,0,.731.731h7.311a.731.731,0,0,0,.731-.731A.731.731,0,0,0-19.065,229.026Z",
    fill: "#9d9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M-19.065,232.682h-7.311a.732.732,0,0,0-.731.731.731.731,0,0,0,.731.731h7.311a.731.731,0,0,0,.731-.731A.731.731,0,0,0-19.065,232.682Z",
    fill: "#9d9c9c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusculoskeletal);
export default __webpack_public_path__ + "static/media/musculoskeletal.beb01263fc2edb009a7c8e9ea07f4cd2.svg";
export { ForwardRef as ReactComponent };